import { Button, Header, LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import type { CSSProperties } from 'react'
import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { StoreContext } from '@store/Root.store'
import { IkanoNamensabgleich } from './icons/IkanoNamensabgleich'
import { actionReport } from '@methods/actionReport'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

export const MicropaymentInfoWithVideoIdIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { screenSize, isMobile } = store.AppState
  const { micropaymentInfoWithVideoIdPage: trans } = store.TranslationsState.translationsNew

  const [mobileContainerHeight, setMobileContainerHeight] = useState('')

  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
  })

  const getUserData = async () => {
    setLoading(true)
    const { data } = await axios.get<{
      firstName: string
      lastName: string
    }>(`${API_URL}/${ONBOARDING_SERVICE_PATH}/user-data`, {
      withCredentials: true,
    })
    setUser(data)
    setLoading(false)
  }

  const handleProceed = async () => {
    actionReport({
      type: 'event.onboarding-web.tink.PROCEED_CTA_CLICKED',
      payload: {},
    })

    store.ScenarioState.nextPage()
  }

  useEffect(() => {
    if (screenSize.width && screenSize.width <= 980) {
      setMobileContainerHeight(`calc(${window.innerHeight}px - 120px)`)
    }
  }, [screenSize.width])

  useEffect(() => {
    getUserData()
  }, [])

  return (
    <div className="page-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div
            className="layout__content-container-with-scroll"
            style={
              isMobile
                ? ({ '--ccws-mobile-height': mobileContainerHeight } as CSSProperties)
                : undefined
            }
          >
            <Header>{trans.header}</Header>

            <div className="ikano__micropayment-namensabgleich">
              <IkanoNamensabgleich />
            </div>

            <div className="generic__paragraph">
              {trans.contentBPart1} <b>{trans.contentBPart2}</b> {trans.contentBPart3}{' '}
              <b>{trans.contentBPart4}</b>
              <br />
              <br />
              {trans.yourName || 'Dein Name auf dem Antrag ist:'}
            </div>

            <div className="generic__paragraph-with-border">
              {user.firstName} {user.lastName}
            </div>

            <div className="generic__paragraph">
              {trans.contentBPart5} {trans.contentBPart6} {trans.contentBPart7}
              <br />
              <br />
              {trans.contentBLogPart1} {trans.contentBLogPart2}
            </div>

            {isMobile ? (
              <div className="layout__margined m-0-0-40" />
            ) : (
              <div className="layout__margined m-0-0-15" />
            )}
          </div>
          <div className="layout__content-container-bottom-fixed">
            {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}

            <Button onClick={() => handleProceed()}>
              <span className="generic__button-text">{trans.continue}</span>
            </Button>
          </div>
        </>
      )}
    </div>
  )
})
